module.exports = __webpack_public_path__ + "img/bg.8a162e4b.jpg";